export default {
	detail: state => id => state.campaign.find(item => item.id == id),
	filterSubKategori: state => idKategori => state.subKategoriList.filter(v => v.kategori !== null).filter(v => v.kategori.id === idKategori) 
}